import Translatable from '../translatable_text/Translatable';

function Intro2() {
  return (
    <section className="page-intro-cerv section-padding">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 lg:col-span-8 bord-thin-right rest">
            <div className="grid grid-cols-12 gap-6 justify-end rest">
              <div className="col-span-12 md:col-span-5 rest">
                <div className="cont">
                  <div className="mb-40">
                    <h2 className="fz-100 numb-font">1.</h2>
                  </div>
                  <h4>
                    <Translatable>
                      Our Mission
                    </Translatable>
                  </h4>
                  <div className="text mt-30">
                    <span style={{ color: 'gray', lineHeight: '1.5' }}>
                      <Translatable>
                        At GCAD, we transform technological ideas into scalable and profitable products through professional development and operation. Our goal is to prepare these ventures to attract strategic partnerships and investments, all within an exclusive business pathway focused on innovation, sustainability, and added value.
                      </Translatable>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-span-12 md:col-span-5 rest">
                <div className="img fit-img bord-thin-left">
                  <img src="/light/assets/imgs/wide-bg/wide-bg11.webp" alt="img" />
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-6 justify-end bord-thin-top rest">
              <div className="col-span-12 md:col-span-5 rest">
                <div className="img fit-img">
                  <img src="/light/assets/imgs/wide-bg/wide-bg1.webp" alt="img" />
                </div>
              </div>
              <div className="col-span-12 md:col-span-5 rest">
                <div className="cont bord-thin-left">
                  <div className="mb-40">
                    <h2 className="fz-100 numb-font">2.</h2>
                  </div>
                  <h4>
                    <Translatable>
                      Our Vision
                    </Translatable>
                  </h4>
                  <div className="text mt-30">
                    <span style={{ color: 'gray', lineHeight: '1.5' }}>
                      <Translatable>
                        To position GCAD as the leading Saudi platform for enabling technological innovation by developing and managing high-readiness tech projects that unlock promising investment opportunities in both local and global markets.
                      </Translatable>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-4 rest">
            <div className="bord-thin-top mt-100 position-re">
              <div className="grid grid-cols-12 gap-6">
                <div className="col-span-12 md:col-span-11">
                  <div className="cont">
                    <div className="mb-40">
                      <h2 className="fz-100 numb-font">3.</h2>
                    </div>
                    <h4>
                      <Translatable>
                        Why Us?
                      </Translatable>
                    </h4>
                    <div className="text mt-30">
                      <span style={{ color: 'gray', lineHeight: '1.5' }}>
                        <Translatable>
                          GCAD stands out by offering market-ready tech projects developed through a unique end-to-end model that ensures innovation, scalability, and strategic investment opportunities across diverse sectors.
                        </Translatable>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="bg-dots bg-img"
                data-background="/light/assets/imgs/patterns/dots.png"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Intro2;
